import React from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var StockNameExchange = function (props) {
    var device = DeviceContext();
    return (React.createElement("div", { className: "dflexend flex-wrap" },
        React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1" }, props.stockName),
        React.createElement("div", { className: "txt_secondary-gray ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "DMSansNormal_12_400" : "DMsanR_10_400") },
            "\u00A0",
            props.exchangeVal)));
};
export default StockNameExchange;
